import type { Tournament } from 'api/cms/tournaments';

import type { TopPlayer } from 'api/tournaments';
import { updateOrAppendById } from 'helpers/updateOrAppendById';
import produce from 'immer';

export type State = {
  userTournamentsStatuses: TopPlayer[];
  cmsTournaments: Tournament[];
  pendingCMSTournaments: boolean;
};

export enum ACTION_TYPE {
  SET_USER_TOURNAMENTS_STATUSES = 0,
  UPDATE_USER_TOURNAMENT_STATUS = 1,
  SET_CMS_TOURNAMENTS = 2,
  SET_PENDING_CMS_TOURNAMENTS_STATUS = 3,
}

export type Action =
  | {
      type: ACTION_TYPE.SET_USER_TOURNAMENTS_STATUSES;
      payload: { userTournamentsStatuses: TopPlayer[] };
    }
  | {
      type: ACTION_TYPE.UPDATE_USER_TOURNAMENT_STATUS;
      payload: { userTournamentStatus: TopPlayer };
    }
  | {
      type: ACTION_TYPE.SET_CMS_TOURNAMENTS;
      payload: { tournaments: Tournament[] };
    }
  | {
      type: ACTION_TYPE.SET_PENDING_CMS_TOURNAMENTS_STATUS;
      payload: { pending: boolean };
    };

type Reducer = (state: State, action: Action) => State;

export const reducer: Reducer = (state, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ACTION_TYPE.SET_USER_TOURNAMENTS_STATUSES:
        draft.userTournamentsStatuses = action.payload.userTournamentsStatuses;
        break;
      case ACTION_TYPE.UPDATE_USER_TOURNAMENT_STATUS:
        draft.userTournamentsStatuses = updateOrAppendById(
          draft.userTournamentsStatuses,
          action.payload.userTournamentStatus,
          'tournamentId'
        );
        break;
      case ACTION_TYPE.SET_CMS_TOURNAMENTS:
        draft.cmsTournaments = action.payload.tournaments;
        break;
      case ACTION_TYPE.SET_PENDING_CMS_TOURNAMENTS_STATUS:
        draft.pendingCMSTournaments = action.payload.pending;
        break;
    }
  });
